import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  keywords = [],
  canonical,
  type = "website",
  schema,
  image = "https://customer-assets.emergentagent.com/job_5612de96-9817-4dde-8f5e-f254b2b066d6/artifacts/5ie5ityv_Untitled%20%283000%20x%20800%20px%29.png",
}) {
  const fullTitle = title
    ? `${title} | K & K Associates`
    : "K & K Associates | Advocates & Solicitors | New Delhi";
  const desc =
    description ||
    "K & K Associates — premier law firm in Defence Colony, New Delhi. Advocates & Solicitors providing world-class legal services in Litigation, IP, Arbitration, M&A and more.";
  const kw = keywords.length
    ? keywords.join(", ")
    : "K and K Associates, advocates Delhi, solicitors Delhi, law firm Defence Colony";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="K & K Associates" />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
      {canonical && <link rel="canonical" href={canonical} />}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
